
import PropTypes from 'prop-types'

export default function UserName ({ user, ...rest }) {
    const given = user?.user_metadata?.given
    const family = user?.user_metadata?.family
  const userName = [ given, family ].join(' ')

    const suffixes = user?.user_metadata?.suffix ?? null
  const displaySuffix = suffixes && suffixes.length ? suffixes.join(', ') : ''

  const userDisplayName = displaySuffix.length
    ? [ userName, displaySuffix ].join(', ')
    : userName

  return userDisplayName
    ? (
      <span className='user-name-wrapper'>
        <span
          className='user-name'
          {...rest}
        >
          {userDisplayName}
        </span>
      </span>
    )
    : null
}

UserName.propTypes = {
  user: PropTypes.instanceOf(Object).isRequired
}
